import { render, staticRenderFns } from "./AnnualReport2025_2026.vue?vue&type=template&id=35351f10&scoped=true"
import script from "./AnnualReport2025_2026.vue?vue&type=script&lang=js"
export * from "./AnnualReport2025_2026.vue?vue&type=script&lang=js"
import style0 from "./AnnualReport2025_2026.vue?vue&type=style&index=0&id=35351f10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35351f10",
  null
  
)

export default component.exports